import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { Context } from '../shared'
import { ContrastQueryParameters } from '../endpoint-helpers'
import {
  AttackEventFilterQueryArgs,
  attackEventFilterArgs
} from '../types/attack-event-filter-query-args'
import {
  attackEventAggregationType,
  AttackEventAggregation
} from '../types/attack-event-aggregation'
import { appendAttackEventFiltersToBody } from '../endpoint-helpers/attack-events'
import { extractTermBuckets, extractKeyValueBuckets } from './helpers/shared'

export enum AttackEventBucket {
  APPLICATIONS = 'applications',
  ATTACKERS = 'attackers',
  ENVIRONMENTS = 'environments',
  RESULTS = 'results',
  RULES = 'rules',
  SERVERS = 'servers',
  SEVERITIES = 'severities',
  TAGS = 'tags',
  SOURCE_NAMES = 'source-names'
}

export const attackEventAggregations: GraphQLFieldConfig<
  any,
  Context,
  AttackEventFilterQueryArgs
> = {
  description: 'Get the aggregation for a collection of attack events',
  type: new GraphQLNonNull(attackEventAggregationType),
  args: attackEventFilterArgs,
  async resolve(_source, args, context): Promise<AttackEventAggregation> {
    const { organizationID, filters } = args

    const params = new ContrastQueryParameters()
    params.append('expand', 'skip_links')

    const getAggregation = (bucketType: AttackEventBucket) =>
      context.connector.post(
        `${organizationID}/rasp/events/filter/${bucketType}/listing?${params}`,
        appendAttackEventFiltersToBody(filters)
      )

    const [
      applications,
      attackers,
      environments,
      results,
      rules,
      servers,
      severities,
      tags,
      sourceNames
    ] = await Promise.all([
      getAggregation(AttackEventBucket.APPLICATIONS).then(
        extractKeyValueBuckets
      ),
      getAggregation(AttackEventBucket.ATTACKERS).then(extractTermBuckets),
      getAggregation(AttackEventBucket.ENVIRONMENTS).then(extractTermBuckets),
      getAggregation(AttackEventBucket.RESULTS).then(extractKeyValueBuckets),
      getAggregation(AttackEventBucket.RULES).then(extractKeyValueBuckets),
      getAggregation(AttackEventBucket.SERVERS).then(extractKeyValueBuckets),
      getAggregation(AttackEventBucket.SEVERITIES).then(extractTermBuckets),
      getAggregation(AttackEventBucket.TAGS).then(extractTermBuckets),
      getAggregation(AttackEventBucket.SOURCE_NAMES).then(
        extractKeyValueBuckets
      )
    ])

    return {
      applications,
      attackers,
      environments,
      results,
      rules,
      servers,
      severities,
      tags,
      sourceNames
    }
  }
}
